import React from "react";
import { Autocomplete, FormControl, FormLabel } from "@mui/joy";
import { colorTokens } from "../../../styles/globalStyles";
import { useBilling } from "../../../contexts/api/billing";

type Props = {
  value: string;
  onChange: (value: string) => void;
  entity: "prestations" | "products";
};

export default function GroupAutocomplete({ value, onChange, entity }: Props) {
  const { listGroups } = useBilling();
  const [options, setOptions] = React.useState<string[]>([]);

  React.useEffect(() => {
    listGroups(entity).then((data) => {
      if (data) setOptions(data);
    });
  }, [listGroups, entity]);

  return (
    <FormControl>
      <FormLabel sx={{ color: colorTokens.text.muted }}>Catégories</FormLabel>
      <Autocomplete
        freeSolo
        options={options}
        value={value}
        onChange={(_e, newValue) => onChange(newValue ?? "")}
        onInputChange={(_e, newInput) => onChange(newInput ?? "")}
        placeholder="Saisir ou choisir une catégorie..."
        sx={{
          backgroundColor: colorTokens.bg.surfaceMuted,
          color: colorTokens.text.primary,
          border: `1px solid ${colorTokens.border.strong}`,
          borderRadius: "8px",
          "&:focus-within": { borderColor: colorTokens.border.focus },
          "& input": { color: colorTokens.text.primary },
        }}
        slotProps={{
          listbox: {
            sx: {
              backgroundColor: colorTokens.bg.surfaceMuted,
              border: `1px solid ${colorTokens.border.default}`,
              "& .MuiAutocomplete-option": { color: colorTokens.text.primary },
            },
          },
        }}
      />
    </FormControl>
  );
}
